import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { locationShape } from 'react-router';

import MainNavigation from './MainNavigation';  // eslint-disable-line import/no-named-as-default
import MainFooter from './MainFooter';
import InfoBar from 'components/InfoBar';
import { getInfoState, getChatState } from 'selectors';
import * as actions from 'actions';

let ChatWindow, ChatBubble;
ChatWindow = require('./ChatWindow').default;
ChatBubble = require('./ChatBubble').default;

class Main extends Component {

  constructor() {
    super();
    this.handleChatBubbleClicked = this.handleChatBubbleClicked.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleChatBubbleClicked() {
    this.props.onChatBubbleClicked();
  }

  handleClick(event) {
    this.props.onClick(event.target);
  }

  render() {
    return (
      <div onClick={this.handleClick}>
        <MainNavigation location={this.props.location.pathname} />

        {this.props.children}

        {ChatWindow && <ChatWindow />}

        <MainFooter />

        {this.props.isErrorsInfoBarVisible && <InfoBar type="alert" message={this.props.errorsInfoBarMessage} onClose={this.props.onErrorsInfoBarClose} />}

        {this.props.isConnectionInfoBarVisible &&  <InfoBar type="alert" message={this.props.connectionInfoBarMessage} onClose={this.props.onConnectionInfoBarClose} />}

        {this.props.isChatBubbleVisible && ChatBubble && <ChatBubble />}
      </div>
    );
  }
}

Main.propTypes = {
  location: locationShape,
  children: PropTypes.element,
  isErrorsInfoBarVisible: PropTypes.bool,
  isConnectionInfoBarVisible: PropTypes.bool,
  isChatBubbleVisible: PropTypes.bool,
  errorsInfoBarMessage: PropTypes.string,
  connectionInfoBarMessage: PropTypes.string,
  onErrorsInfoBarClose: PropTypes.func,
  onConnectionInfoBarClose: PropTypes.func,
  onChatBubbleClicked: PropTypes.func,
  onClick: PropTypes.func
};

const mapStateToProps = (state) => {
  const errorsState = getInfoState(state, 'errors');
  const isErrorsInfoBarVisible = errorsState.visible;
  const errorsInfoBarMessage = errorsState.message;

  const connectionState = getInfoState(state, 'connectionState');
  const isConnectionInfoBarVisible = connectionState.visible;
  const connectionInfoBarMessage = connectionState.message;

  const chatState = getChatState(state);

  return {
    isErrorsInfoBarVisible,
    errorsInfoBarMessage,
    isConnectionInfoBarVisible,
    connectionInfoBarMessage,
    isChatBubbleVisible: chatState.isActive
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onErrorsInfoBarClose: () => {
      dispatch(actions.infoClose('errors'));
    },
    onConnectionInfoBarClose: () => {
      dispatch(actions.infoClose('connectionState'));
    },
    onClick: target => {
      const { tagName, href, hostname } = target;

      if(tagName === 'A' && hostname !== window.location.hostname) {
        dispatch(actions.analyticsOutlinkSelected(href));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);



/** WEBPACK FOOTER **
 ** ./src/members/Main/index.js
 **/